<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "居间费申请" : "居间费申请" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='400'
      :fullscreen='$isMobile'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field label="申请金额" hide-details='auto' outlined :rules="number" v-model="form.money"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='3' label="备注信息" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/contract/mediator.js'

  export default {
    name: 'InvoiceAdd',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          merge: false
        })
      },
      surplusMoney: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && value <= this.surplusMoney) || `金额必填且不得超过${this.surplusMoney}`,
        ],
        form: {
          id: '',
          contractId: '',
          money: '',
          remark: ''
        },
        defForm: {
          id: '',
          contractId: '',
          money: '',
          remark: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form.contractId = this.item.data.id
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
          this.$refs.form.resetValidation()
        }
      },
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    }
  }
</script>

<style>
</style>
